import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {getParam} from '../utils/utils';
import {cloneObject} from '../utils/utils';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import ViewCapability from "../components/ViewCapability";
import ViewSolution from "../components/ViewSolution";
import ViewMetadata from "../components/ViewMetadata";
import Rendition from '../components/Rendition';


import ListParticipations from "../components/ListParticipations";
import SelectSystem from "../components/SelectSystem";
import SelectCapability from "../components/SelectCapability";
import FormDependency from "../components/FormDependency";
import {getSolution, getCapability, addCapabilityToSolution, editCapability} from "../utils/utilsSolution";


import D3Graphviz from "../components/D3Graphviz";


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Capability extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleControls = this.handleControls.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.addDependency = this.addDependency.bind(this);
        this.removeDependency = this.removeDependency.bind(this);
        this.updateDependency = this.updateDependency.bind(this);
        this.moveDependencyUp = this.moveDependencyUp.bind(this);
        this.moveDependencyDown = this.moveDependencyDown.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadSolution(id){

        let StateChange = {};
        StateChange.Solution = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Solution = data;
            StateChange.renderState = "loaded";
            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Solution = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getSolution(this.dsd, id,onLoad, onFail);
        }

        this.setState(StateChange);

        return;                
    };

    loadCapability(id){

        let StateChange = {};
        StateChange.Capability = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Capability = data;

            StateChange.FormData = {...data};
            
            // Initialize Dependencies as empty array if not present, or filter out empty objects
            if (!StateChange.FormData.Dependencies) {
                StateChange.FormData.Dependencies = [];
            } else {
                // Filter out empty dependency objects (those without idCapability)
                StateChange.FormData.Dependencies = StateChange.FormData.Dependencies.filter(
                    dep => dep.idCapability
                );
            }

            if (data.Solution){
                StateChange.Solution = data.Solution;
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsSolution(data.Solution._id);
                }
            }

            StateChange.renderState = "loaded";

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (StateChange.Capability.Solution.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied"
                        StateChange.errorMessage = "You cannot add or edit this Capability"
                    break;
                }
            }

            this.setState(StateChange);

            this.fetchViz(id);

            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Capability = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getCapability(this.dsd, id,onLoad, onFail);
        }

        this.setState(StateChange);

        return;        
    };

    fetchViz(id) {

       const onDoneDot = function(dot) {
           this.setState({ dot: dot });
       }.bind(this);

       const onFailDot = function(error) {
           console.error('Failed to fetch DOT:', error);
       }.bind(this);

       getCapability(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

   };


    setup(){

        let StateChange = {

            mode: "view",

            idCapability: null,
            idSolution: null,

            Solution: null,
            Capability: null,

            isUpdated: false,

            isFailed: false,
            isError: false,
            errorMessage: null,

            renderState: null,

            FormData: {},
            OfferEdit:false,
            fallbackpath: null,

            Controls: {
            },

            vizNodeId: null,
            dot: null

        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idCapability = getParam('id', this.props);
        StateChange.idSolution = getParam('idSolution', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idSolution){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Solution not specified when adding a Capability"
                }
                break;
            default:
                if (StateChange.idSolution){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Solution should not be specified for an existing Capability"
                }
                if (!StateChange.idCapability){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Capability not specified"
                }
                break;
        }


        if (StateChange.idSolution){
            this.loadSolution(StateChange.idSolution);
        }
        if (StateChange.idCapability){
            this.loadCapability(StateChange.idCapability);
        }

        if (this.props.location.state && this.props.location.state.fallbackpath){
            StateChange.fallbackpath = this.props.location.state.fallbackpath;
        }
        else{
            if (StateChange.mode == "new"){
                if (StateChange.idSolution){
                    StateChange.fallbackpath = `/solution/${StateChange.idSolution}`;
                }        
            }
        }



        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;        
        this.setState({"FormData": FormData});

        return;

    };

    handleControls(event){

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        Controls[FormFieldName] = FormFieldValue;        
        this.setState({"Controls": Controls});

        return;

    }


    handleSubmit(event) {

        const onError = function(e){
            let StateChange = {};
            StateChange.renderState = "error";

            StateChange.errorMessage = e.message;

            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                    if (e.response.data.fields){
                        for (const field in e.response.data.fields){
                            StateChange.invalidFields = e.response.data.fields
                        }
    
                    }
                }
            }
    
            this.setState(StateChange);
            return;
        }.bind(this);

        window.scrollTo(0,0);
        switch (event.target.name){
            
            case 'btnCancel':

                this.setState({                    
                    renderState: "cancelled"
                })

                switch (this.state.mode){
                    case "edit":
                        this.props.navigation(`/capability/${this.state.idCapability}`);
                        break;
                    case "new":
                        if (this.state.fallbackpath){
                            this.props.navigation(`${this.state.fallbackpath}`);
                        }
                        break;
                }

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    renderState: "updating"
                })
        
                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(idCapability){
                            this.props.navigation(`/capability/${idCapability}`);
                            return;
                        }.bind(this);

                        addCapabilityToSolution(this.dsd, this.state.idSolution,this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/capability/${this.state.idCapability}`);
                            return;
                        }.bind(this);

                        editCapability(this.dsd, this.state.idCapability,this.state.FormData, onUpdate, onError);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        const newMode = event.target.value;
        this.setState({mode: newMode});
                
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    handleVizClick(event) {

        let StateChange = {};

        let idNode = null;

        let target = null;
        if (event.target.tagName == "a"){
            target = event.target;
        } else{
            if ("parentElement" in event.target){
                if (event.target.parentElement.tagName == "a"){
                    target = event.target.parentElement;
                }
            }
        }

        if (target){
            if ("href" in target){
                idNode = target.href.baseVal;
                StateChange.vizNodeId = idNode;
            }
        }
        

        if (!idNode){
            return;
        }
        
        let partsVizNodeId = idNode.split('_');
        switch(partsVizNodeId[0]){
            case 'capability':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/capability/${partsVizNodeId[1]}`);
                }
                break;
            case 'role':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/role/${partsVizNodeId[1]}`);
                }
                break;
            case 'system':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/system/${partsVizNodeId[1]}`);
                }
                break;
            case 'participation':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/participation/${partsVizNodeId[1]}`);
                }
                break;
    
        }

        this.setState(StateChange);

        event.preventDefault();

    };

    addDependency(){
        let FormData = {...this.state.FormData};
        FormData.Dependencies = [...(FormData.Dependencies || []), {}];
        
        this.setState({"FormData": FormData});
    }

    removeDependency(seq){
       let FormData = {...this.state.FormData};
       FormData.Dependencies = [...(FormData.Dependencies || [])];
       FormData.Dependencies.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});
    }

    updateDependency(seq, Dependency){
       let FormData = {...this.state.FormData};
       FormData.Dependencies = [...(FormData.Dependencies || [])];
       FormData.Dependencies[seq-1] = Dependency;

       this.setState({"FormData": FormData});
    }


    moveDependencyUp(seq){

        let FormData = {...this.state.FormData};
        FormData.Dependencies = [...(FormData.Dependencies || [])];
        
        // Swap with previous item
        [FormData.Dependencies[seq-2], FormData.Dependencies[seq-1]] =
        [FormData.Dependencies[seq-1], FormData.Dependencies[seq-2]];
        
        this.setState({"FormData": FormData});

    }

    moveDependencyDown(seq){

       let FormData = {...this.state.FormData};
       FormData.Dependencies = [...(FormData.Dependencies || [])];
      
       // Swap with next item
       [FormData.Dependencies[seq-1], FormData.Dependencies[seq]] =
       [FormData.Dependencies[seq], FormData.Dependencies[seq-1]];
      
       this.setState({"FormData": FormData});


    }

    FormDependency(mode, seq, Dependency = {}){
        

        let onMoveUp = null;
        if (seq>1) {
            onMoveUp = this.moveDependencyUp;
        }

        let onMoveDown = null;
        if (this.state.FormData.Dependencies){
            if (seq<this.state.FormData.Dependencies.length) {
                onMoveDown = this.moveDependencyDown;
            }
        }


        return (

            <FormDependency 
                key={seq}
                mode={mode}
                onAdd={this.addDependency}
                onRemove={this.removeDependency}
                onUpdate={this.updateDependency}
                {...(onMoveUp && { onMoveUp:onMoveUp})}
                {...(onMoveDown && { onMoveDown:onMoveDown})}
                Dependency={Dependency} 
                seq={seq}
                idSolution={this.state.Solution._id}  
            />
            
        )
    }

    FormDependencies(){

        let seqNext = 1;
        if (this.state.FormData.Dependencies){
            seqNext = this.state.FormData.Dependencies.length + 1;
        }
        return (
            <fieldset>
                <legend>Dependencies</legend>
                <PD.P>Specify which other Capabilities this Capability depends upon</PD.P>
                {this.state.FormData.Dependencies &&
                    this.state.FormData.Dependencies.map(
                        (Dependency, posDependency) => 
                        {
                            let seq = posDependency+1;
                            return(
                                this.FormDependency('edit', seq, Dependency)
                            )
                        }
                    )
                }
                {this.FormDependency('new', seqNext)}
            </fieldset>
        );

    }

    visualise(){
    
        if (!this.state.Capability){
            return null;
        }

        try {

            const images = this.dsd.getSolutionImages();

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.state.dot} images={images}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        let idSolution = null;
                        if (this.state.Solution){
                            idSolution = this.state.Solution._id;
                        }

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Capability</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Select label="Type" name='type'  onChange={this.handleChange} value={this.state.FormData.type}>
                                        {
                                            this.dsd.config.CapabilityTypes.map(
                                                (type, posType) => 
                                                    {
                                                        return(
                                                            <option key={posType} value={type}>{type}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor label='Pre-Condition' name="precondition" value={this.state.FormData.precondition} onChange={this.handleChange}/>
                                    <PD.Editor label='Post-Condition' name="postcondition" value={this.state.FormData.postcondition} onChange={this.handleChange}/>

                                    <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <SelectSystem
                                        label='System'
                                        name="idSystem"
                                        onChange={this.handleChange}
                                        idSolution={idSolution}
                                        value={this.state.FormData.idSystem}
                                    />
                                    <SelectCapability
                                        label='Group'
                                        name="idCapabilityGroup"
                                        onChange={this.handleChange}
                                        idSolution={idSolution}
                                        {...(this.state.FormData.idSystem && { idSystem: this.state.FormData.idSystem })}
                                        type='Group'
                                        value={this.state.FormData.idCapabilityGroup}
                                    />

                                    <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.CapabilityStatuses.map(
                                                (status, posStatus) => 
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    {this.FormDependencies()}
                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Capability</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewCapability Capability={this.state.Capability}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        const countParticipations = this.state.Capability.Participations.length;

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Capability:{this.state.Capability.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                    </span>
                                }

                                <ViewCapability Capability={this.state.Capability}/>

                                <br/>

                                <PD.Tabs>

                                    <div label='Visualise'>
                                        {this.visualise()}
                                    </div>


                                    <div label='Solution'>
                                        <ViewSolution Solution={this.state.Solution} />
                                    </div>

                                    <div label={`Participations(${countParticipations})`}>
                                        <ListParticipations filters={{"idCapability":this.state.idCapability}} />
                                    </div>


                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Capability} />
                                    </div>


                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/capabilities"
                                            id={this.state.idCapability}
                                        />
                                    </div>

                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };
}


// Wrap and export
export default function Capability_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Capability {...props} navigation={navigation} location={location} params={params} />;
  }
